// extracted by mini-css-extract-plugin
export default {"sliderBlock":"Slider_sliderBlock__L3vJX"};